import { motion } from 'framer-motion';

export const SectionHeader = ({
  overline,
  title,
  subtitle,
  centered = false,
  className = ''
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className={`mb-12 md:mb-16 ${centered ? 'text-center max-w-3xl mx-auto' : ''} ${className}`}
    >
      {overline && (
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#00A2B5] mb-3 block">
          {overline}
        </span>
      )}
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-black tracking-tight text-slate-900 mb-4">
        {title}
      </h2>
      {subtitle && (
        <p className="text-lg text-slate-600 leading-relaxed">
          {subtitle}
        </p>
      )}
    </motion.div>
  );
};

export default SectionHeader;
